export const HomeName = 'homeComponent';
